/**
 * Prefix used for Stuller events
 */
const STULLER_EVENT_PREFIX = 'stuller-'

/**
 * Stuller event names
 */
var stullerEvents = {
  ping: false,
  'react-mount': false,
  'form-builder-submission': false,
  'track-event': false,
  'track-universal-event': false,
  'live-chat-open': false,
  'cms-content-recommendations': false,
  'add-a-head-modal-scrolltop': false,
  'add-a-head-react-remount': false,
  'cms-preview-tmc': false,
  'accent-stones-toggle-change': false,
  'digital-goldsmith-modal-launch': false
}
var stullerEventsQueue = {
  ping: [],
  'react-mount': [],
  'form-builder-submission': [],
  'track-event': [],
  'track-universal-event': [],
  'live-chat-open': [],
  'cms-content-recommendations': [],
  'add-a-head-modal-scrolltop': [],
  'add-a-head-react-remount': [],
  'cms-preview-tmc': [],
  'accent-stones-toggle-change': [],
  'digital-goldsmith-modal-launch': []
}

/**
 * Helper function to dispatch Stuller events
 */
function dispatchStullerEvent (eventName, detail) {
  if (stullerEvents[eventName] == null) {
    throw new Error('dispatchStullerEvent received an invalid eventName: ' + eventName)
  }
  const event = new CustomEvent(STULLER_EVENT_PREFIX + eventName, { cancelable: true, detail })

  // If the event listener is not ready, queue the event
  if (stullerEvents[eventName] === false) {
    stullerEventsQueue[eventName].push(event)
    return true
  }

  return window.dispatchEvent(event)
}

/**
 * Helper function to create/replace Stuller event listeners
 */
function addStullerEventListener(eventName, eventHandler) {
  if (stullerEvents[eventName] == null) {
    throw new Error('addStullerEventListener received an invalid eventName: ' + eventName)
  }
  const data = window.__stullerEventListeners || {}
  window.__stullerEventListeners = data

  const stullerEventName = STULLER_EVENT_PREFIX + eventName
  if (data[eventName] != null) {
    window.removeEventListener(stullerEventName, data[eventName])
  }

  data[eventName] = eventHandler
  window.addEventListener(stullerEventName, eventHandler)

  // Dispatch any queued events
  stullerEvents[eventName] = true
  if (stullerEventsQueue[eventName].length > 0) {
    stullerEventsQueue[eventName].forEach(event => window.dispatchEvent(event))
    stullerEventsQueue[eventName] = []
  }

  // window.stullerEvents = stullerEvents
}
